<template>
    <UnhandledErrorBoundary>
        <GlobalConfirmationModalHandler>
            <MainLayout v-if="isReady">
                <RouterView />
            </MainLayout>
            <LoadingPage v-else />
        </GlobalConfirmationModalHandler>
    </UnhandledErrorBoundary>
</template>

<script setup lang="ts">
import LoadingPage from '@/pages/other/LoadingPage.vue'
import { computed, onMounted, provide } from 'vue'
import MainLayout from '@/layouts/MainLayout.vue'
import { useMainStore } from '@/store/mainStore'
import { useMetaDataStore } from '@/store/metaDataStore'
import { useAuthStore } from '@/store/authStore'
import { THEME_KEY } from 'vue-echarts'
import { useTheme } from '@/composables/useTheme'
import { ECHARTS_THEME_DARK, ECHARTS_THEME_LIGHT } from '@/utils/echarts-theme'

import UnhandledErrorBoundary from '@/components/error-boundary/UnhandledErrorBoundary.vue'
import GlobalConfirmationModalHandler from '@/components/global-confirmation-modal/GlobalConfirmationModalHandler.vue'

const mainStore = useMainStore()
const metaDataStore = useMetaDataStore()
const authStore = useAuthStore()
const { isDarkMode } = useTheme()

const isReady = computed(() => mainStore.isAppReady)

provide(THEME_KEY, computed(() => (isDarkMode.value ? ECHARTS_THEME_DARK : ECHARTS_THEME_LIGHT)))

onMounted(async () => {
    mainStore.setAuthenticationAsReady()
    await authStore.initializeAuthentication()
    await metaDataStore.setupMetaDataInformation()
})
</script>
